import { FormValue } from '@flatsy/types/Applications'

export const convertProStatusIntoProSituation = (status?: string | null): string => {
  if (status === FormValue.proStatus.STUDENT) {
    return FormValue.proSituation.STUDENT
  }

  if (status === FormValue.proStatus.RETIRED) {
    return FormValue.proSituation.RETIRED
  }

  if (
    status === FormValue.proStatus.RSA ||
    status === FormValue.proStatus.BENEFITS ||
    status === FormValue.proStatus.UNEMPLOYED
  ) {
    return FormValue.proSituation.WITHOUT_ACTIVITY
  }

  if (
    status === FormValue.proStatus.CEO ||
    status === FormValue.proStatus.TRADER ||
    status === FormValue.proStatus.SELF_EMPLOYED
  ) {
    return FormValue.proSituation.UNEMPLOYED
  }

  if (
    status === FormValue.proStatus.CDI ||
    status === FormValue.proStatus.CDD ||
    status === FormValue.proStatus.CDI_PROBATION ||
    status === FormValue.proStatus.CIVIL_SERVANT
  ) {
    return FormValue.proSituation.EMPLOYED
  }

  return ''
}

export const convertProSituationIntoProStatus = (
  situation?: string | null,
  status?: string | null
): string => {
  if (situation === FormValue.proStatus.STUDENT) {
    return FormValue.proSituation.STUDENT
  }

  if (situation === FormValue.proStatus.RETIRED) {
    return FormValue.proSituation.RETIRED
  }

  return status || ''
}
